module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img6.01b4e6cf.jpg";